import React, { useEffect, useState, useRef, useCallback } from "react";
import {
  GoogleMap,
  LoadScript,
  Autocomplete,
  Marker,
} from "@react-google-maps/api";
import { GOOGLE_MAP_KEY } from "../redux/api/Constants";

const libraries = ["places"];

const containerStyle = {
  width: "100%",
  height: "50vh",
};

const GoogleMapPage = ({ setFormData, formData }) => {
  const center = {
    lat: formData?.lat ? formData?.lat : 13.05321,
    lng: formData?.lng ? formData?.lng : 80.217639,
  };

  const [mapCenter, setMapCenter] = useState(center);
  const mapRef = useRef(null);
  const autoCompleteRef = useRef(null);

  const onLoad = useCallback((map) => {
    mapRef.current = map;
    setFormData((prev) => ({ ...prev, latitude: center?.lat }));
    setFormData((prev) => ({ ...prev, longitude: center?.lng }));
  }, []);

  const onCenterChanged = () => {
    if (mapRef.current) {
      const newCenter = {
        lat: mapRef.current.getCenter().lat(),
        lng: mapRef.current.getCenter().lng(),
      };
      setMapCenter(newCenter);
      setFormData((prev) => ({ ...prev, latitude: newCenter?.lat }));
      setFormData((prev) => ({ ...prev, longitude: newCenter?.lng }));
      console.log("New center:", newCenter);
    }
  };

  const onAutoCompleteLoad = (autocomplete) => {
    autoCompleteRef.current = autocomplete;
  };

  const onPlaceChanged = () => {
    if (autoCompleteRef.current !== null) {
      const place = autoCompleteRef.current.getPlace();
      if (place.geometry) {
        const newPos = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
        };
        setMapCenter(newPos);
        console.log("New center2:", newPos);
        setFormData((prev) => ({ ...prev, latitude: newPos?.lat }));
        setFormData((prev) => ({ ...prev, longitude: newPos?.lng }));
        mapRef.current.panTo(newPos);
      }
    }
  };

  const mapOptions = {
    fullscreenControl: false, // Hide fullscreen button
    mapTypeControl: false, // Hide map/satellite toggle
    streetViewControl: false, // Hide street view pegman
    zoomControl: false, // Hide zoom in/out buttons
    rotateControl: false, // Hide compass/rotate
    scaleControl: false, // Hide scale bottom left
    clickableIcons: false, // Disable default place icons
    disableDefaultUI: false, // Keep default UI if needed, or true to hide all
  };

  return (
    <div>
      {" "}
      <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1">
        Map Location
      </h4>
      <div>
        <LoadScript googleMapsApiKey={GOOGLE_MAP_KEY} libraries={libraries}>
          <div
            className="p-4"
            style={{
              width: "100%",
              border: "1px solid rgb(179 218 185)",
              position: "relative",
            }}
          >
            <Autocomplete
              onLoad={onAutoCompleteLoad}
              onPlaceChanged={onPlaceChanged}
              className="d-flex justify-content-center"
            >
              <input
                type="text"
                placeholder="Search a place"
                style={{
                  width: "40%",
                  padding: "12px 16px",
                  borderRadius: "12px",
                  border: "1px solid #ccc",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                  fontSize: "16px",
                  outline: "none",
                  zIndex: 1,
                  position: "absolute",
                  margin: "2%",
                }}
              />
            </Autocomplete>

            <GoogleMap
              mapContainerStyle={containerStyle}
              center={mapCenter}
              zoom={14}
              options={mapOptions}
              onLoad={onLoad}
              // onIdle={onCenterChanged}
              onDragEnd={onCenterChanged}
            >
              <Marker position={mapCenter} />
            </GoogleMap>
          </div>
        </LoadScript>
      </div>
    </div>
  );
};

export default GoogleMapPage;
